import {createContext, ReactNode} from 'react';
import {StatusModalStates} from 'components/StatusModal';
import {Participant} from '@guestapp/sdk';
import {OnboardingState} from '../store/useOnboardingStore';

type CreateGuestsArgs = {
  customLeaderGuestId?: string;
  customParticipants?: Participant[];
  guestsData?: OnboardingState['guestsData'];
};

type GuestCreationContextType = {
  createGuests: (data?: CreateGuestsArgs) => Promise<void>;
  isProcessing: boolean;
  isModalOpen: boolean;
  guestRegistrationStatus: StatusModalStates;
  successSubtitle: ReactNode;
  errorMessage: string;
  errorMessages: string[];
  closeModalAndReset: () => void;
};

const GuestCreationContext = createContext<GuestCreationContextType | undefined>(
  undefined,
);

export {GuestCreationContext};
